
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  BoxObject,
  ChartLoadingStatus,
  ScenarioNameType,
  SummaryFormattedType,
} from '@/types';
import { colorMap } from '@/assets/colors/colors';
import ChartComponent from '@/components/DataTab/Charts/ChartComponents/ChartComponent.vue';
import { breakBetweenWords } from '@/helpers/txtwrapper';

@Component({
  components: {
    ChartComponent,
  },
})
export default class BoxChart extends Vue {
  @Prop() readonly summaryData!: SummaryFormattedType[];
  @Prop() readonly summaryDataStatus!: ChartLoadingStatus;
  @Prop() readonly chartId!: number;

  get scenarioList(): ScenarioNameType[] {
    let scenarios = this.$store.getters.selectedScenarioList;
    if (this.chartId == 8 && !this.selectedArea.name.includes('Yampa')) {
      scenarios = scenarios.filter(
        (scenario: string) => scenario !== 'Baseline',
      );
    }
    return scenarios;
  }

  get chartData(): BoxObject[] {
    const data: BoxObject[] = [];
    this.scenarioList.forEach(item => {
      data.push({
        type: 'box',
        name: item,
        marker: {
          color: colorMap[item],
        },
        q1: [],
        median: [],
        q3: [],
        upperfence: [],
        lowerfence: [],
        x0: item,
      });
    });

    this.summaryData.forEach(datapoint => {
      data.forEach(object => {
        if (datapoint.scenario === object.name) {
          object.upperfence.push(datapoint.max);
          object.lowerfence.push(datapoint.min);
          object.median.push(datapoint.median);
          object.q1.push(datapoint.q1);
          object.q3.push(datapoint.q3);
        }
      });
    });

    return data;
  }

  get selectedArea() {
    return this.$store.getters.selectedArea;
  }

  get layout() {
    const unit = this.$t(`data.chartTables.${this.chartId}.unit`);
    const label = this.$t(`data.chartTables.${this.chartId}.axisLabels.y`);
    return {
      xaxis: {
        fixedrange: true,
        tickmode: 'array',
        tickvals: this.scenarioList,
        ticktext: this.scenarioList.map(word => breakBetweenWords(word)),
        tickfont: {
          size: this.$vuetify.breakpoint.smAndDown
            ? 8
            : this.$vuetify.breakpoint.mdAndDown
            ? 9
            : 10,
        },
        tickangle: this.$vuetify.breakpoint.mdAndDown ? 90 : 0,
      },
      yaxis: {
        fixedrange: true,
        automargin: true,
        title: {
          text: `${label}(${unit})`,
          standoff: 10,
        },
        hoverformat: '.2f',
      },

      showlegend: false,
      hovermode: 'closest',
      paper_bgcolor: 'transparent',
      plot_bgcolor: 'transparent',
      height: 500,
      // removes empty heading above graph
      margin: {
        l: 50,
        r: 50,
        b: 140,
        t: 5,
        pad: 3,
      },
    };
  }
}
